import * as bank from 'src/api/bank'
import {
  SET_BANKS
} from 'src/store/mutation-types'

const getAllBanks = ({commit, dispatch}, params) => {
  dispatch('toggleLoadding', true, {root: true})
  bank.getAllBank(params).then(response => {
    if (response.code === 200) {
      dispatch('toggleLoadding', false, {root: true})
      commit(SET_BANKS, response.data)
    } else {
      dispatch('toggleLoadding', false, {root: true})
      commit(SET_BANKS, [])
    }
  })
}

export default{
  getAllBanks
}



// WEBPACK FOOTER //
// ./src/components/bank/store/actions.js